import {
  FormPhone,
  FormInput,
  FormDropDown,
  FormDatepicker,
} from '../../forms/final-form-fields'
import { defineMessages } from 'react-intl'
import moment from 'moment'
import { Fragment } from 'react'

export const messages = defineMessages({
  gender: {
    id: 'gender',
    defaultMessage: 'Gender',
  },
  firstName: {
    id: 'first_name',
    defaultMessage: 'First name',
  },
  lastName: {
    id: 'last_name',
    defaultMessage: 'Last name',
  },
  email: {
    id: 'email',
    defaultMessage: 'Email',
  },
  dob: {
    id: 'dob',
    defaultMessage: 'Date of birth',
  },
  street: {
    id: 'street',
    defaultMessage: 'Street & №',
  },
  city: {
    id: 'city',
    defaultMessage: 'City',
  },
  zip: {
    id: 'zip',
    defaultMessage: 'ZIP / postal code',
  },
  state: {
    id: 'state',
    defaultMessage: 'State / province / region',
  },
  country: {
    id: 'country',
    defaultMessage: 'Country',
  },
  phone: {
    id: 'mobile-phone',
    defaultMessage: 'Mobile phone number',
  },
  genderRequired: {
    id: 'gender-required',
    defaultMessage: 'Required so that your equipment can be prepared',
  },
  dobRequired: {
    id: 'dob-required',
    defaultMessage:
      'Required so that the min. age for this activity can be validated',
  },
  password: {
    id: 'password',
    defaultMessage: 'Password',
  },
  emailElearningRequired: {
    id: 'email-elearning-required',
    defaultMessage: 'Required so that you can receive your eLearning code',
  },
})

function ParticipantForm({ field, isCheckout, isElearning }) {
  const maxDate = moment().subtract(10, 'years').toDate()
  const CountriesList = window.info.countryList
  const GENDER = window.info.account.GENDER
  return (
    <div>
      {!isCheckout && (
        <div className='form-row'>
          <FormDropDown
            name={`${field}.genderTitle`}
            title={messages.gender}
            isRequired
            isArrayCollection
            hint={messages.genderRequired}
            options={GENDER}
          />
        </div>
      )}
      <div className='form-row'>
        <FormInput
          name={`${field}.firstName`}
          label={messages.firstName}
          isRequired
        />
        <FormInput
          name={`${field}.lastName`}
          label={messages.lastName}
          isRequired
        />
      </div>
      <div className='form-row'>
        <FormDatepicker
          name={`${field}.dob`}
          label={messages.dob}
          maxDate={maxDate}
          isRequired
          hint={messages.dobRequired}
        />
        {isCheckout
          ? (
            <FormDropDown
              name={`${field}.genderTitle`}
              title={messages.gender}
              isRequired
              isArrayCollection
              hint={messages.genderRequired}
              options={GENDER}
            />
          )
          : (
            <FormInput name={`${field}.street`} label={messages.street} />
          )}
      </div>
      {isElearning && (
        <div className='form-row'>
          <FormInput
            name={`${field}.email`}
            label={messages.email}
            isRequired
            hint={messages.emailElearningRequired} />
        </div>
      )}
      {!isCheckout && (
        <Fragment>
          <div className='form-row'>
            <FormInput name={`${field}.city`} label={messages.city} />
            <FormInput name={`${field}.zip`} label={messages.zip} />
          </div>
          <div className='form-row'>
            <FormInput name={`${field}.state`} label={messages.state} />
            <FormDropDown
              name={`${field}.country`}
              title={messages.country}
              options={CountriesList}
            />
          </div>
          <div className='form-row'>
            <FormPhone name={`${field}.phone`} label={messages.phone} />
            <FormInput name={`${field}.email`} label={messages.email} />
          </div>
        </Fragment>
      )}
    </div>
  )
}

export default ParticipantForm
